import { Message } from 'rsuite';
import React from 'react';
import PropTypes from 'prop-types';
import { get, getOr } from 'lodash/fp';

const composeConnectionMessage = (
  hasClientCredentials,
  isConnected,
  lastAuthError
) => {
  if (!hasClientCredentials) {
    return {
      connectionMessageType: 'info',
      connectionMessage:
        'Your SMTP account is not connected. Please complete the setup to enable email sending.'
    };
  }
  if (isConnected) {
    return {
      connectionMessageType: 'success',
      connectionMessage:
        'Your SMTP account is successfully connected and ready to send emails.'
    };
  }

  if (lastAuthError) {
    const errorDescription = get('error_description', lastAuthError);
    const errorMessage = !errorDescription
      ? getOr(
          'An error occurred while authenticating. Please try again.',
          'message',
          lastAuthError
        )
      : errorDescription;
    return {
      connectionMessageType: 'error',
      connectionMessage: errorMessage
    };
  }

  return {
    connectionMessageType: 'error',
    connectionMessage:
      'SMTP connection failed. Please verify your credentials and configuration.'
  };
};

const SmtpAccountConnectionMessage = ({
  hasClientCredentials,
  isConnected,
  lastAuthError
}) => {
  const { connectionMessageType, connectionMessage } = composeConnectionMessage(
    hasClientCredentials,
    isConnected,
    lastAuthError
  );
  return (
    <Message
      type={connectionMessageType}
      description={connectionMessage}
      showIcon
      style={{ marginBottom: 16 }}
    />
  );
};

SmtpAccountConnectionMessage.propTypes = {
  hasClientCredentials: PropTypes.bool.isRequired,
  isConnected: PropTypes.bool.isRequired,
  lastAuthError: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string])
};

SmtpAccountConnectionMessage.defaultProps = {
  lastAuthError: null
};

export default SmtpAccountConnectionMessage;
